
//import { Table } from '@material-ui/core';
import React, { Fragment } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { Card, CardBody, CardText, Collapse } from 'reactstrap';
import { ArcaHttpChangeLog } from '../../../code/ArcaHttpChangeLog';
import { ArcaDate } from '../../../code/Types/ArcaDate';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { DateWrapper } from '../Datepickers/DateWrapper';
import { ArcaLink } from '../Fields/ArcaLink';
import { StatusBar } from '../StatusBar';

export class ChangeLogPanel extends ArcaComponent {

    constructor(props) {
        super(props);

        this.state = {
            isError: false,
            message: null,
            list: null,
            selected: "1",
            referenceDate: ArcaDate.Today
        };
    }

    async componentDidMount() {
        if (this.props.personId !== undefined) {
            await ArcaHttpChangeLog.GetAsync(
                this.props.personId,
                (list => {
                    this.setState({ list })
                }),
                (msg => this.setState({ isError: true, message: msg })),
                (msg => this.setState({ isError: true, message: msg })
                )
            );
        }
        else {
            await this.getScreenDetails(this.state.referenceDate)
        }
    }

    async getScreenDetails(selectedDate) {
        await ArcaHttpChangeLog.GetByDateAsync(
            selectedDate,
            (list => {
                this.setState({ list })
            }),
            (msg => this.setState({ isError: true, message: msg })),
            (msg => this.setState({ isError: true, message: msg })
            )
        );

        this.setState({ referenceDate: selectedDate })
    }

    async handleDateChange(e) {
        if (e.target.value === '') {
            return
        }

        var selectedDate = new ArcaDate(new Date(e.target.value))

        await this.getScreenDetails(selectedDate)
    }

    render() {
        let { isError, message, list, selected, referenceDate } = this.state;

        return (
            <Fragment>
                <h1>Change</h1>

                {this.props.personId === undefined
                    ? <h3 className='centerText'>
                        Changes prior to:
                        <DateWrapper
                            referenceDate={referenceDate}
                            handleDateChange={(e) => this.handleDateChange(e)} />
                    </h3>
                    : null}


                <StatusBar message={message} isError={isError} />

                {/*<Table className='table table-striped' aria-labelledby='tabelLabel'>*/}
                <Container>
                    {list?.map((item, key) =>
                        <Row key={key}>
                            <Col>
                                <ArcaLink
                                    colour="secondary"
                                    onClick={() => this.setState({ selected: (selected !== key) ? key : 'allCollapsed' })}
                                    text={item.Date.DayAndMonthPretty}
                                    width='100%'
                                />

                                <Collapse isOpen={selected === key}>
                                    <Card>
                                        <CardBody>
                                            {item.Changes.map((c, kc) =>
                                                <Fragment key={kc}>
                                                    <CardText>
                                                        {
                                                            this.props.personId === undefined
                                                                ? `${c.Updated.Time}: [${c.EditedBy}]: ${c.Table} - ${c.Field}: ${c.OldValue}->${c.NewValue}`
                                                                : `${c.Updated.Time}: ${c.Table} - ${c.Field}: ${c.OldValue}->${c.NewValue}`
                                                        }
                                                    </CardText>
                                                </Fragment>
                                            )}
                                        </CardBody>
                                    </Card>

                                </Collapse>
                            </Col>
                        </Row>
                    )}
                </Container>
            </Fragment>
        )
    }
}